<script>
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
// This component wraps each child component in a div so the wrapper and the
// child can be styled separately. This is especially important when prop
// 'vertical' is 'true' in order to deal with css rotation issues.

export default {
  name: 'NsCarouselItems',
  functional: true,
  props: {
    spacing: {
      type: Number,
      default: 0,
    },
    vertical: Boolean,
    width: {
      type: Number,
      default: 50,
    },
  },
  render(createElement, { children, props }) {
    return children.map((child, index) =>
      createElement(
        'div',
        {
          class: ['ns-carousel-item', { vertical: props.vertical }],
          // don't add spacing to last item
          ...(index !== children.length - 1 && {
            style: {
              marginRight: `${props.spacing}px`,
              // minWidth: `${props.width}px`
            },
          }),
        },
        [child]
      )
    );
  },
};
</script>

<style lang="scss" scoped>
.ns-carousel-item {
  position: relative;

  &.vertical {
    > ::v-deep * {
      transform: rotate(-90deg);
    }
  }
}
</style>
